module.exports = __webpack_public_path__ + "img/user.25755dd0.gif";